import React, { PropsWithChildren, ReactElement } from 'react'
import { Box, ThemeUIStyleObject } from 'theme-ui'
import { keyframes } from '@emotion/react'

export default function LoadingPlaceholder({
  isLoading,
  children,
  sx,
}: PropsWithChildren<{ isLoading?: boolean; sx?: ThemeUIStyleObject }>): ReactElement {
  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            width: '7.2rem',
            height: '1.2rem',
            backgroundColor: 'white30',
            opacity: '0.5',
            borderRadius: '10rem',
            animation: `${keyframes({ '50%': { opacity: '1' } })} 2s 1s backwards infinite`,
            ...sx,
          }}
        />
      ) : (
        children
      )}
    </>
  )
}
